import { apiConnector } from "../apiconnector";
import { homeContentEndpoints as endpoints } from "../apis";

const header = token => ({ Authorization:`Bearer ${token}` });
const set = kind => kind === "mentorship" ? {
  active:endpoints.GET_ACTIVE_MENTORSHIPS, all:endpoints.GET_ALL_MENTORSHIPS, create:endpoints.CREATE_MENTORSHIP, update:endpoints.UPDATE_MENTORSHIP, remove:endpoints.DELETE_MENTORSHIP,
} : {
  active:endpoints.GET_ACTIVE_PROGRAMS, all:endpoints.GET_ALL_PROGRAMS, create:endpoints.CREATE_PROGRAM, update:endpoints.UPDATE_PROGRAM, remove:endpoints.DELETE_PROGRAM,
};

export const getActiveHomeContent = async kind => { try { const response=await apiConnector("GET",set(kind).active); return response?.data?.items||[]; } catch { return []; } };
export const getAllHomeContent = async (kind,token) => { const response=await apiConnector("GET",set(kind).all,null,header(token)); return response?.data?.items||[]; };
export const createHomeContent = (kind,data,token) => apiConnector("POST",set(kind).create,data,header(token));
export const updateHomeContent = (kind,id,data,token) => apiConnector("PATCH",`${set(kind).update}/${id}`,data,header(token));
export const deleteHomeContent = (kind,id,token) => apiConnector("DELETE",`${set(kind).remove}/${id}`,null,header(token));
